@if (antragsLimit | async; as limit) {
  @if (limit.isLimited) {
    <ebeihilfe-segmented-circle
      class="progress-circle"
      [current]="limit.antraegeLeftToday"
      [maxAmount]="limit.limit"
      [progressText]="'new_antrag.label.antraege_left' | translate: { antraegeLeftToday: limit.antraegeLeftToday }" />
  }
}
<div class="stepper">
  <portal-single-step
    [currentStep]="currentStep()"
    [stepNumber]="1"
    [stepActive]="(currentStep() | asMainStep) < einreichungStep.UPLOADING"
    [stepDone]="(currentStep() | asMainStep) >= einreichungStep.UPLOADING" />
  <div class="line"></div>
  <portal-single-step
    [currentStep]="currentStep()"
    [stepNumber]="2"
    [stepActive]="(currentStep() | asMainStep) === einreichungStep.UPLOADING"
    [stepDone]="(currentStep() | asMainStep) > einreichungStep.UPLOADING" />
  <div class="line"></div>
  <portal-single-step
    [currentStep]="currentStep()"
    [stepNumber]="3"
    [stepActive]="(currentStep() | asMainStep) === einreichungStep.COMPLETE"
    [stepDone]="(currentStep() | asMainStep) >= einreichungStep.COMPLETE" />
</div>
